import * as React from 'react';
import * as att from "./style.module.scss";
export const AttentionEng = ({ imgSrc }) => {
  return (
    <section className={att.attention}>
      <div className="container">
        <div className={att.wrapper}>
          <img
            className={att.image}  
            src={imgSrc}
            alt=""
          />
          <div className={att.content}>
            <h2 className={att.title}>Обратите внимание:</h2>
            <ul className={att.list}>
              <li className={att.item}>
                <strong>Соблюдать дедлайны строго обязательно</strong>
              </li>
              <li className={att.item}>
                В&nbsp;случае отставания, вам дважды предоставляется право перейти в&nbsp;группу, которая в&nbsp;данный момент проходит нужный вам урок или занимается с&nbsp;меньшей интенсивностью (3&nbsp;раза в&nbsp;неделю вместо 5-ти)
              </li>
              <li className={att.item}>
                Если после двойного перехода дедлайны всё равно не&nbsp;соблюдаются, участник покидает группу без возврата оплаты.
              </li>
              <li className={att.item}>
                Вы&nbsp;можете задавать вопросы в&nbsp;чате в&nbsp;любое время, однако в&nbsp;ответах возможны задержки&nbsp;&mdash; куратор будет отвечать, согласно своему режиму работы.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
